module.exports = __webpack_public_path__ + "img/CECA_Neutrophils.e5c94cf6.png";